import React from 'react';
import { translate } from 'react-i18next';

import List from './List';

class Memos extends React.Component {
  render() {
    const { user, goal } = this.props;

    return <List user={user} goal={goal} />;
  }
}

export default translate()(Memos);



// WEBPACK FOOTER //
// ./src/goals/memos/index.js